<template>
  <el-dialog
    title=""
    :visible.sync="visible"
    width="30%"
    append-to-body
    top="10vh"
  >
    <div class="container">
      <img src="./img/dialog-bg.png" class="bg-img" alt="" />
      <div class="content">
        <div>大渡口区</div>
        <div style="width: 100%" class="mt-10">
          <el-input v-model="key" placeholder="搜索小区">
            <div slot="suffix">
              <div
                class="flex justify-center items-center cursor-pointer"
                style="height: 42px; width: 50px"
              >
                <img
                  @click="onSearch"
                  style="width: 20px; height: 20px"
                  src="./img/search.png"
                  alt=""
                />
              </div>
            </div>
          </el-input>
          <div class="list__container">
            <div
              v-for="(item, index) in filterList"
              :key="index"
              class="flex items-center item mt-5 pl-10 cursor-pointer"
              :class="selectItem.name == item.name ? 'active' : ''"
              @click="onCheckItem(item)"
            >
              <img
                src="./img/house.png"
                alt=""
                style="height: 20px; width: 20px"
              />
              <div class="ml-4">{{ item.name }}</div>
            </div>
          </div>

          <div slot="footer">
            <div
              class="flex justify-center items-center cursor-pointer"
              style="width: 100%; margin-top: 50px"
              @click="handleSubmit"
            >
              <dv-decoration-11
                style="width: 200px; height: 60px"
                :color="['#456AD6', '#456AD6']"
                >确 定</dv-decoration-11
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="visible = false">确 定</el-button>
    </span> -->
  </el-dialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      key: "",
      filterList: [],
      list: [],
      selectItem: {},
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show(n) {
      n && this.init();
    },
  },
  computed: {
    ...mapGetters(["globalData"]),
    visible: {
      get() {
        return this.show;
      },
      set(n) {
        this.$emit("update:show", n);
      },
    },
    // list() {
    //   return this.globalData.communities.map((v) => {
    //     return {
    //       name: v,
    //     };
    //   });
    // },
  },
  methods: {
    onSearch() {
      if (!this.key) {
        this.filterList = this.list;
      }
      this.filterList = this.list.filter((v) => v.name.includes(this.key));
    },
    onCheckItem(item) {
      this.selectItem = item;
    },
    init() {
      this.key = "";
      let list = [
        {
          name: "跳蹬镇",
          position: "bottom: 200px; left: 280px;",
          key: "tiaodeng",
        },
        {
          name: "建胜镇",
          position: "bottom: 260px;right: 280px;",
          key: "jiansheng",
        },
        {
          name: "茄子溪街道",
          position: "top: 160px;right: 260px;",
          key: "liupeiqie",
        },
        {
          name: "春晖路街道",
          position: "top: 160px;right: 350px;",
          key: "chunhui",
        },
        {
          name: "九宫庙街道",
          position: "top: 100px;right: 280px;",
          key: "jiugong",
        },
        {
          name: "新山村街道",
          position: "top: 50px;right: 260px;",
          key: "xinshancun",
        },
        {
          name: "跃进村街道",
          position: "top: 16px;right: 190px;",
          key: "yuejin",
        },
        {
          name: "八仙镇街道",
          position: "top: 10px;right: 380px;",
          key: "baxian",
        },
      ];
      this.filterList = list;
      this.list = list;
      this.selectItem = {};
    },
    handleSubmit() {
      //   this.$store
      //     .dispatch("app/getGlobalData", { key: this.key })
      //     .then((resp) => {});
      this.$store.dispatch("app/changeMapKey", this.selectItem.key);

      this.visible = false;

      console.log(this.visible);
    },
  },
  mounted() {
    this.filterList = this.list;
  },
};
</script>
<style scoped lang="less">
.container {
  position: relative;
  .bg-img {
    position: absolute;
    height: 100%;
  }
  .content {
    position: relative;
    z-index: 2;
    color: #fff;
    padding-top: 6%;
    padding-left: 30px;
    padding-right: 30px;
    font-weight: bold;
    font-size: 20px;
  }
  .list__container {
    margin-top: 30px;
    height: 370px;
    overflow: scroll;
    .item {
      width: 100%;
      height: 39px;
      background: linear-gradient(
        90deg,
        #161f4e 0%,
        rgba(4, 24, 40, 0.28) 100%
      );
      //   opacity: 0.28;

      font-size: 16px;
      color: #01b3e6;
      font-weight: 500;
    }
    .item:hover {
      color: #fff;
      background: linear-gradient(
        90deg,
        #2a3895 0%,
        rgba(4, 24, 40, 0.28) 100%
      );
    }
    .active {
      color: #fff;
      background: linear-gradient(
        90deg,
        #2a3895 0%,
        rgba(4, 24, 40, 0.28) 100%
      );
    }
  }
}
::v-deep {
  .el-dialog {
    // 取消阴影和背景色
    background: rgba(0, 0, 0, 0);

    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0);

    box-shadow: 0 1px 3px rgba(0, 0, 0, 0);
  }
  .el-input__inner {
    height: 42px;
    border: 1px solid #077fd4;
    border-radius: 8px;
    background: none;
    color: #01b3e6;
  }
  .el-dialog__header {
    height: 20px;
    padding: 0;
  }
}
</style>
